export const nav = {
  dashboard: 'Dashboard',
  customers: 'Customers',
  customerGroups: 'Customer Groups',
  leads: 'Leads',
  documentStorage: 'Library',
  documentLibrary: 'Library',
  suppliers: 'Suppliers',
  notes: 'Sticky Notes',
  richNotes: 'Notebook',
  appointments: 'Appointments',
  customerPortal: 'Customer Portal',
  portalPreview: 'Portal Preview',
  missingItems: 'Missing Items',
  customerProjects: 'Customer Projects',
  customerRelationshipLogs: 'Relationship Logs',
  products: 'Products',
  categories: 'Categories',
  webCategories: 'Webshop Categories',
  productCategoryAssignment: 'Product Categorization',
  warehouse: 'Warehouses',
  inventory: 'Inventory',
  warranty: 'Warranty',
  offers: 'Quotations',
  ai_quotations: 'AI Quotations',
  contracts: 'Documents',
  templates: 'Templates',
  documentVariables: 'Variables',
  formBuilder: 'Forms & Lists',
  formBuilderEditor: 'Form Builder',
  flowBuilder: 'Flow Builder',
  myForms: 'My Forms',
  worksheets: 'Worksheets',
  deals: 'Deals',
  reports: 'Reports',
  settings: 'Settings',
  profile: 'Profile',
  system_admin: 'System admin',
  storageOptimization: 'Storage Optimization',
  workPagesTemplates: 'Workpage templates',
  filledWorkpage: 'Filled workpage',
  billing: 'Billing',
  billingSubtitle: 'Invoices, proformas and credit notes management',
  tasks: 'Tasks',
  tasksSubtitle: 'Manage tasks and to-dos',
  projects: 'Projects',
  projectsSubtitle: 'Manage and track projects',
  projectBoard: 'Project Board',
  projectReports: 'Project Reports',
  projectReportsSubtitle: 'Analyze projects and tasks',
  flowDebug: 'Flow Logs',
  flowDebugSubtitle: 'Flow execution logs and debugging',
  orders: 'Orders',
  delivery_notes: 'Delivery Notes',
  sales: 'Sales',
  organization: 'Organization',
  selectOrganization: 'Select Organization',
  groups: {
    crm: 'CRM & Contacts',
    customerPortal: 'Customer Portal',
    products: 'Products & Inventory',
    sales: 'Sales & Orders',
    documents: 'Documents',
    contracts: 'Contracts',
    forms: 'Forms',
    processes: 'Processes',
    projects: 'Projects & Tasks',
    finance: 'Finance'
  },
  expandSidebar: 'Expand Sidebar',
  collapseSidebar: 'Collapse Sidebar'
}